import { ReactNode } from 'react';

import { User } from '@/types/auth';

import { useAuth } from '@/hooks/useAuth';

type Permission = Extract<keyof User, `can${string}`>;

interface PermissionGateProps {
  permission: Permission;
  children: ReactNode;
  fallback?: ReactNode;
}

const PermissionGate = ({ permission, children, fallback = null }: PermissionGateProps) => {
  const { user } = useAuth();
  return user?.[permission] === true ? children : fallback;
};

export default PermissionGate;
